import React, { useState } from "react";
import axios from "axios";
import en from "../utils/languages/en.jsx";
import fr from "../utils/languages/fr.jsx";
import { useLanguage } from "../utils/LanguageContext";
import "../App.css";
import { toast } from "react-toastify";

const Contact = ({ theme }) => {
  const { language } = useLanguage();
  const translations = {
    en,
    fr,
  };

  const currentTranslations = translations[language];
  const [donnees, setData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    loading: false,
  });

  const resetData = () => {
    setData({
      firstName: "",
      lastName: "",
      email: "",
      subject: "",
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const id = toast.loading("Sending message, please wait...");
    // https://mwafrika-ky6x.onrender.com/send
    const formData = new FormData();
    formData.append("firstName", donnees.firstName);
    formData.append("lastName", donnees.lastName);
    formData.append("email", donnees.email);
    formData.append("subject", donnees.subject);

    axios
      .post("https://formspree.io/f/mgebyorg", donnees, {
        headers: {
          "Content-Type": "application/json",
        },
        method: "POST",
        body: formData,
      })
      .then((res) => {
        if (res.status === 200) {
          //do something else
          toast.update(id, {
            render: "Message sent successfully",
            type: "success",
            isLoading: false,
            autoClose: 3000,
            // pauseOnHover: true,
          });
          // toast.success(res.data.message);
          resetData();
        } else {
          toast.update(id, {
            render: "Message not sent",
            type: "error",
            isLoading: false,
            autoClose: 3000,
            // pauseOnHover: true,
          });
          // toast.error(res.data.message);
        }
      })
      .catch((error) => {
        toast.update(id, {
          render: "Message not sent, try again later",
          type: "error",
          isLoading: false,
          autoClose: 3000,
          pauseOnHover: true,
        });
        // toast.error(error.message);
      });
  };

  const handleChange = (e) => {
    setData({
      ...donnees,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <section className="w-full" id="contact">
      <div className="flex flex-row justify-center items-center h-[40rem] dark:h-[50rem] gap-x-16 w-full dark:w-full xxxs:gap-y-10 mr-auto xxxs:flex-col xxxs:h-auto dark:xxxs:h-auto xxs:gap-y-10 xxs:flex-col xxs:h-auto xs:gap-y-10 xs:flex-col xs:h-auto">
        <div className="flex flex-col gap-4 w-[55%] xxxs:w-full xxs:w-full xs:w-full">
          <h2 className={`${theme === "dark" ? "title2-dark" : "title2"}`}>
            {currentTranslations.contact.title}
          </h2>
          <h3 className="text-lg text-white dark:text-gray-600 lg:text-2xl">
            {currentTranslations.contact.subTitle}
          </h3>
          <p className="text-lg text-gray-400 dark:text-gray-600 lg:text-xl">
            {currentTranslations.contact.info}
          </p>
          <ul className="mt-5 flex flex-col gap-y-3">
            {currentTranslations.contact.list.map(({ icon, title, id }) => (
              <li key={id} className="flex flex-row gap-x-4">
                {icon}
                <h3 className="text-gray-400 dark:text-gray-600 text-lg">
                  {title}
                </h3>
              </li>
            ))}
          </ul>
        </div>
        <div className="flex flex-col gap-4 w-[45%] xxxs:w-full xxs:w-full xs:w-full dark:drop-shadow-2xl dark:rounded-lg dark:bg-gray-800">
          <form
            className="flex flex-col gap-6 dark:py-16"
            onSubmit={handleSubmit}
          >
            <input
              className="w-full dark:w-[90%] dark:mx-auto dark:drop-shadow text-xl px-4 py-3 rounded-lg shadow-lg bg-slate-800 dark:bg-white text-white outline-none dark:text-gray-500 focus:outline-none focus:shadow-outline"
              type="text"
              placeholder={language === "en" ? "First Name" : "Prénom"}
              name="firstName"
              value={donnees.firstName}
              onChange={handleChange}
              required
            />
            <input
              className="w-full dark:w-[90%] dark:mx-auto dark:drop-shadow text-xl px-4 py-3 rounded-lg shadow-lg bg-slate-800 dark:bg-white text-white outline-none dark:text-gray-500 focus:outline-none focus:shadow-outline"
              type="text"
              placeholder={language === "en" ? "Last Name" : "Nom"}
              name="lastName"
              value={donnees.lastName}
              onChange={handleChange}
              required
            />
            <input
              className="w-full dark:w-[90%] dark:mx-auto dark:drop-shadow text-xl px-4 py-3 rounded-lg shadow-lg bg-slate-800 dark:bg-white text-white dark:text-gray-500 outline-none focus:outline-none focus:shadow-outline"
              type="email"
              placeholder="Email"
              name="email"
              value={donnees.email}
              onChange={handleChange}
              required
            />
            <textarea
              className="w-full text-xl dark:w-[90%] dark:mx-auto dark:drop-shadow px-4 py-3 rounded-lg shadow-lg bg-slate-800 dark:bg-white text-white outline-none dark:text-gray-500 focus:outline-none focus:shadow-outline"
              placeholder="Message"
              type="text"
              rows={5}
              cols={6}
              name="subject"
              value={donnees.subject}
              onChange={handleChange}
              required
              autoComplete="off"
            ></textarea>
            <div className="dark:px-7">
              <button
                className="
                  bg-gradient-to-r from-orange-300 to-violet-500 px-5 py-2 rounded-lg shadow-lg hover:shadow-xl hover:bg-gray-600 hover:text-white xxxs:text-sm xxs:text-lg xs:text-lg sm:text-lg
                  "
                type="submit"
              >
                {language === "en" ? "Send" : "Envoyer"}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
};

export default Contact;
